<template>
  <div>
    <!-- About Us -->
    <div v-if="selectedBranch.description">
      <list-header title="About Us" />
      <div class="text-start scss-content">
        {{ selectedBranch.description }}
      </div>
    </div>

    <!-- Operating Hours -->
    <list-header title="Opening Hours" />
    <div class="scss-content d-flex flex-row">
      <div class="d-flex flex-column flex-grow-1 text-start">
        <span>Monday</span>
        <span>Tuesday</span>
        <span>Wednesday</span>
        <span>Thursday</span>
        <span>Friday</span>
        <span>Saturday</span>
        <span>Sunday</span>
      </div>
      <div class="d-flex flex-column text-end">
        <span>{{
          formatOperatingHours(
            selectedBranch.monStartTime,
            selectedBranch.monEndTime
          )
        }}</span>
        <span>{{
          formatOperatingHours(
            selectedBranch.tueStartTime,
            selectedBranch.tueEndTime
          )
        }}</span>
        <span>{{
          formatOperatingHours(
            selectedBranch.wedStartTime,
            selectedBranch.wedEndTime
          )
        }}</span>
        <span>{{
          formatOperatingHours(
            selectedBranch.thuStartTime,
            selectedBranch.thuEndTime
          )
        }}</span>
        <span>{{
          formatOperatingHours(
            selectedBranch.friStartTime,
            selectedBranch.friEndTime
          )
        }}</span>
        <span>{{
          formatOperatingHours(
            selectedBranch.satStartTime,
            selectedBranch.satEndTime
          )
        }}</span>
        <span>{{
          formatOperatingHours(
            selectedBranch.sunStartTime,
            selectedBranch.sunEndTime
          )
        }}</span>
      </div>
    </div>

    <!-- Terms & Conditions -->
    <terms-and-conditions class="mb-5" />
  </div>
</template>

<script>
import ListHeader from "@/components/ListHeader.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import TermsAndConditions from "../../../components/TermsAndConditions.vue";

export default {
  components: { ListHeader, TermsAndConditions },
  name: "About",
  data() {
    return {
      branch: {},
      openingHours: [],
    };
  },
  methods: {
    formatOperatingHours(startTime, endTime) {
      if (startTime === "00:00:00" && endTime === "00:00:00") return "Off";

      return `${moment(startTime, "HH:mm:ss").format("h:mm a")} - ${moment(
        endTime,
        "HH:mm:ss"
      ).format("h:mm a")}`;
    },
  },
  computed: {
    ...mapGetters(["selectedBranch"]),
  },
};
</script>

<style scoped>
.style-about-salon {
  margin: 30px;
}
</style>
